import type React from "react";
import {memo, useMemo} from "react";

import type {ListingAttributesWithQuantity} from "../type";

import type {OptionType} from "@/client/components/Select";
import {TableCell, TableRow} from "@/client/components/Table";
import TableCellEditRemoveActions from "@/client/components/Table/TableCellEditRemoveActions";
import {convertOptionsToMap} from "@/client/utils/convertOptionsToMap";

type Props = {
    item: ListingAttributesWithQuantity;
    index: number;
    attributeOptions: OptionType<ListingAttributesWithQuantity["attributeId"]>[];
    onEdit: (item: ListingAttributesWithQuantity, index?: number) => void;
    onRemove: (index: number) => void;
};

const Item: React.FC<Props> = ({item, index, attributeOptions, onEdit, onRemove}) => {
    const optionsMap = useMemo(() => convertOptionsToMap(attributeOptions), [attributeOptions]);

    return (
        <TableRow>
            <TableCell>{optionsMap[item.attributeId]}</TableCell>
            <TableCell>{item.quantity}</TableCell>
            <TableCell align="end">
                <TableCellEditRemoveActions
                    id={index}
                    item={item}
                    onEdit={onEdit}
                    onRemove={onRemove}
                />
            </TableCell>
        </TableRow>
    );
};

export default memo(Item);
